import { createSlice } from '@reduxjs/toolkit';

const summarySlice = createSlice({
    name: 'summary',
    initialState: {
      items: [],
    },
    reducers: {
        setSummary: (state, action) => {
            state.items = action.payload;
        },
    },
    extraReducers: () => {},
  });

export const { setSummary } = summarySlice.actions;
export default summarySlice.reducer;